<template>
  <div class="deviceList">
    <div class="select">
      <table>
        <tr>
          <td>设备ID
            <el-input v-model="deviceId" placeholder="设备ID"></el-input>
          </td>
          <td>所属门店
            <el-input v-model="store" placeholder="所属门店"></el-input>
          </td>
          <td>所属商户
            <el-input v-model="bs" placeholder="所属商户"></el-input>
          </td>
          <td>所属代理
            <el-input v-model="cs" placeholder="所属代理"></el-input>
          </td>
          <td>设备类型
            <el-select v-model="deviceType" placeholder="请选择设备类型">
              <el-option
                v-for="item in deviceTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td>设备状态
            <el-radio v-model="deviceState" label="1">在线</el-radio>
            <el-radio v-model="deviceState" label="2">离线</el-radio>
          </td>
          <td>开始时间
            <el-date-picker
              v-model="startTime"
              type="date"
              placeholder="开始时间">
            </el-date-picker>
          </td>
          <td>结束时间
            <el-date-picker
              v-model="endTime"
              type="date"
              placeholder="开始时间">
            </el-date-picker>
          </td>
          <td></td>
          <td rowspan="2">
            <el-button style="background-color: #FF9000">搜索</el-button>
            <el-button type="info">清空</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="data">
      <el-table
        :data="deviceData"
        border
        style="width: 100%; height: 93%">
        <el-table-column
          prop="deviceId"
          label="设备ID"
          align="center">
          <el-button type="text" @click="table = true">0000001</el-button>
        </el-table-column>
        <el-table-column
          prop="cs"
          label="所属代理"
          align="center">
        </el-table-column>
        <el-table-column
          prop="store"
          label="安装门店"
          align="center">
        </el-table-column>
        <el-table-column
          prop="store"
          label="设备类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="wareHouse"
          label="所属仓库"
          align="center">
        </el-table-column>
        <el-table-column
          prop="deployTime"
          label="部署时间"
          align="center">
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="100"
          layout="total, prev, pager, next, jumper"
          :total="1000">
        </el-pagination>
      </div>
    </div>

    <div class="detail">
      <el-drawer
        :visible.sync="table"
        :with-header="false"
        direction="rtl"
        size="50%">
        <div class="title">
          <div class="titleImg">
            <img :src="titleImg" width="100%" height="100%" alt=""/>
          </div>
          <div class="orderId">
            <span style="font-size: 16px;">设备ID：0000001</span>
          </div>
          <el-button type="danger">解绑</el-button>
          <div class="orderDetail">
            <table>
              <tr style="height: 18px;">
                <td style="width: 150px;">所属门店</td>
                <td style="width: 150px;">所属商户</td>
                <td style="width: 150px;">所属代理</td>
              </tr>
              <tr style="height: 20px;">
                <td>ktv</td>
                <td>123</td>
                <td>123</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="tag">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="first">
              <table>
                <th>
                  代理信息
                </th>
                <tr style="height: 50px;">
                  <td>代理ID</td>
                  <td>代理姓名</td>
                </tr>
                <tr style="height: 50px;">
                  <td>联系方式</td>
                  <td>分润比例</td>
                </tr>
              </table>
              <el-divider></el-divider>
              <table>
                <th>
                  商户信息
                </th>
                <tr style="height: 50px;">
                  <td>商户ID</td>
                  <td>主体名称</td>
                </tr>
                <tr style="height: 50px;">
                  <td>联系人</td>
                  <td>联系电话</td>
                </tr>
                <tr style="height: 50px;">
                  <td>分润比例</td>
                </tr>
              </table>
              <el-divider></el-divider>
              <table>
                <th>
                  门店信息
                </th>
                <tr style="height: 50px;">
                  <td>门店ID</td>
                  <td>名店名称</td>
                </tr>
                <tr style="height: 50px;">
                  <td>门店联系人</td>
                  <td>门店电话</td>
                </tr>
                <tr style="height: 50px;">
                  <td>门店单价</td>
                  <td>sku</td>
                </tr>
              </table>
              <el-divider></el-divider>
              <table>
                <th>
                  仓库信息
                </th>
                <tr style="height: 50px;">
                  <td>仓库ID</td>
                  <td>仓库名称</td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane label="出入库信息" name="second">
              <div class="inOutWarehouseData">
                <el-table
                  :data="inOutWarehouseData"
                  style="width: 100%">
                  <el-table-column
                    prop="id"
                    label="id"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="warehouse"
                    label="仓库名称"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="operationPerson"
                    label="操作人">
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="操作类型">
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="操作时间">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="订单信息" name="third">
              <div class="orderInfo">
                <el-table
                  :data="orderData"
                  style="width: 100%">
                  <el-table-column
                    prop="id"
                    label="订单编号"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="orderMoney"
                    label="订单金额"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="discountMoney"
                    label="优惠金额">
                  </el-table-column>
                  <el-table-column
                    prop="refundMoney"
                    label="退款金额">
                  </el-table-column>
                  <el-table-column
                    prop="realPayTime"
                    label="实付金额">
                  </el-table-column>
                  <el-table-column
                    prop="rentTime"
                    label="租借时间">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="部署/解绑记录" name="fourth">
              <div class="deployRecord">
                <el-table
                  :data="deployData"
                  style="width: 100%">
                  <el-table-column
                    prop="id"
                    label="id"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="operationPerson"
                    label="操作人">
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="操作类型">
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="操作时间">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceList',
  data() {
    return {
      titleImg: require('../../../static/image/powerbankorder/bianji.png'),
      deviceId: '',
      store: '',
      bs: '',
      cs: '',
      table: false,
      activeName: 'first',
      deviceTypeOptions: [{
        value: '1',
        label: '6口'
      }, {
        value: '2',
        label: '9口'
      }, {
        value: '3',
        label: '12口'
      }, {
        value: '4',
        label: '36口'
      }],
      deviceType: '',
      deviceState: '1',
      startTime: '',
      endTime: '',
      deviceData: [{}],
      inOutWarehouseData: [{
        id: '000000001'
      }],
      orderData: [{
        id: '0000001'
      }]
    }
  }
}
</script>

<style scoped>
.deviceList {
  background-color: #FFFFFF;
  width: 100%;
  height: 100%;
}

.select {
  width: 100%;
  height: 11.5%;
  margin-bottom: 20px;
}

.select table {
  width: 100%;
  font-size: 16px;
  text-align: left;
}

.select table .el-input, .el-select {
  width: 70%;
  text-align: left;
}

.select table tr td {
  width: 16%;
}

.data {
  width: 100%;
  height: 88%;
}

.data .el-button {
  color: #4691F3;
}

/deep/ :focus {
  outline: none;
}

.title .el-button {
  background-color: red;
  border-radius: 10px;
  float: right;
  margin-top: -25px;
  margin-right: 20px;
}

.orderDetail table {
  display: block;
  text-align: left;
  float: left;
  margin-top: 10px;
  margin-left: -125px;
  font-size: 16px;
}

.title {
  height: 11%;
  background-color: #4691F3;
}

.titleImg {
  width: 5%;
  height: 40%;
}

.titleImg img {
  display: block;
  float: left;
  margin: 10px 20px;
}

.orderId {
  float: left;
  margin-top: -20px;
  margin-left: -10px;
}

.tag table {
  text-align: left;
  width: 80%;
}

.tag table tr td {
  width: 30%;
}
/deep/ .el-pagination .btn-prev {
  padding: 0;
  margin: 0;
  width: 1%;
}
/deep/ .el-pagination .btn-next {
  padding: 0;
  margin: 0;
  width: 1%;
}
</style>



// WEBPACK FOOTER //
// src/pages/devicemanagement/devicelist.vue